export const isElectron =
	typeof window !== "undefined" &&
	!!(window as unknown as { electron?: unknown }).electron;

export const isWeb = !isElectron;

/**
 * Base URL for shareable links such as invites. In Electron
 * `window.location.origin` is `file://`, so VITE_APP_URL wins there.
 */
export function getAppBaseUrl(): string {
	return import.meta.env.VITE_APP_URL || window.location.origin;
}
